(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[71533,65250],{

/***/ 71533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TepezzaWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/styles/variables/tepezzaVariables.module.scss
var tepezzaVariables_module = __webpack_require__(71020);
var tepezzaVariables_module_default = /*#__PURE__*/__webpack_require__.n(tepezzaVariables_module);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/tepezza/logo/index.tsx


function TepezzaLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "306",
        height: "45",
        fill: "none",
        viewBox: "0 0 306 45",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_66)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1E4E35",
                        d: "M33.759 6.927c-2.232 0-7.827-1.91-11.76-3.855-1.975-1.024-3.505-2.027-3.976-2.69a.856.856 0 00-.707-.37.857.857 0 00-.707.37c-.47.663-1.996 1.666-3.975 2.69C8.7 5.029 3.106 6.927.874 6.927a.857.857 0 00-.857.857v16.443c0 7.522 12.728 15.1 16.241 16.883.273.156.56.286.857.39.06.004.12.004.18 0h.077c.061.004.123.004.184 0 .296-.105.583-.236.857-.39 3.491-1.765 16.202-9.344 16.202-16.883V7.776a.857.857 0 00-.856-.849z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        fillRule: "evenodd",
                        d: "M16.436 3.79a1.323 1.323 0 011.83 0l.004.004c.363.36 1.14.867 2.194 1.436a41.315 41.315 0 003.648 1.717 38.942 38.942 0 003.958 1.418c1.256.365 2.349.58 3.118.58v.788c-.884 0-2.064-.241-3.338-.612a39.723 39.723 0 01-4.04-1.447 42.104 42.104 0 01-3.72-1.751c-1.054-.568-1.92-1.12-2.371-1.566a.536.536 0 00-.736 0c-.45.446-1.314.998-2.365 1.566a41.88 41.88 0 01-3.72 1.751 39.703 39.703 0 01-4.044 1.447c-1.274.37-2.455.612-3.34.612h-.001V9.34l.002.394a.532.532 0 00-.53.532v13.833c0 1.917 1.048 4.074 3.237 6.428l-.577.536c-2.25-2.418-3.447-4.76-3.447-6.964V10.265a1.32 1.32 0 011.313-1.32h.002c.77 0 1.865-.215 3.122-.58a38.923 38.923 0 003.96-1.418 41.105 41.105 0 003.648-1.717c1.054-.569 1.828-1.076 2.187-1.435l.006-.005z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M21.943 17.552a1.285 1.285 0 01-1.38-1.067c.276-.011.535-.13.725-.33a1.03 1.03 0 00.295-.737v-1.422a1.775 1.775 0 00-.518-1.26 1.8 1.8 0 00-1.26-.518h-4.978a1.767 1.767 0 00-1.778 1.778v1.422a1.071 1.071 0 001.02 1.067 1.286 1.286 0 01-1.375 1.067 2.061 2.061 0 00-2.142 2.142v6.405a.356.356 0 00.71 0v-6.414a1.366 1.366 0 011.423-1.422 2.013 2.013 0 002.104-1.778h5.042a2.005 2.005 0 002.1 1.778 1.38 1.38 0 011.426 1.422v7.827a1.066 1.066 0 01-1.071 1.067h-9.948a1.076 1.076 0 01-1.007-.711h10.963a.356.356 0 000-.711H10.916a.356.356 0 00-.356.355 1.778 1.778 0 001.778 1.778h9.956a1.786 1.786 0 001.783-1.778v-7.827a2.065 2.065 0 00-2.143-2.142l.01.009zM13.76 15.41v-1.422a1.067 1.067 0 011.067-1.067h4.978a1.059 1.059 0 011.003.71H14.81a.356.356 0 000 .712h6.05v1.067a.355.355 0 01-.108.253.364.364 0 01-.253.102h-6.383a.356.356 0 01-.355-.355z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M18.027 19.685h-1.405a.356.356 0 00-.355.356v1.422h-1.423a.356.356 0 00-.355.356v1.426a.355.355 0 00.355.356h1.423v1.422a.355.355 0 00.218.328c.044.018.09.028.137.028h1.423a.357.357 0 00.355-.356v-1.422h1.423a.357.357 0 00.252-.107.335.335 0 00.103-.249V21.82a.335.335 0 00-.103-.249.355.355 0 00-.252-.107H18.4v-1.422a.355.355 0 00-.355-.356h-.018zm1.423 2.49v.71h-1.423a.36.36 0 00-.355.36v1.41h-.711v-1.422a.36.36 0 00-.356-.36h-1.422v-.712h1.44a.35.35 0 00.355-.355v-1.422h.711v1.422a.352.352 0 00.107.253.334.334 0 00.249.102l1.405.013z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1E4E35",
                        d: "M56.259 36.907V14.87h-7.506v-4.781h20.05v4.794h-7.485v22.024h-5.06zM86.2 32.482a10.307 10.307 0 01-3.427 3.637 9.52 9.52 0 01-5.27 1.388 10.092 10.092 0 01-3.877-.732 9.423 9.423 0 01-3.093-2.044 9.267 9.267 0 01-2.04-3.089 10.577 10.577 0 01-.02-7.681 9.536 9.536 0 015.003-5.231 9.254 9.254 0 013.856-.784 9.965 9.965 0 013.933.728 8.032 8.032 0 012.887 2.027 8.783 8.783 0 011.761 3.05 11.86 11.86 0 01.6 3.826v.45a2.453 2.453 0 00-.039.428c-.028.14-.04.285-.038.428H72.598c.075.678.285 1.333.617 1.928a4.614 4.614 0 002.677 2.138 5.918 5.918 0 001.688.244 4.816 4.816 0 002.794-.767 5.607 5.607 0 001.739-1.932l4.087 1.988zm-4.46-7.116a3.175 3.175 0 00-.321-1.088 3.775 3.775 0 00-.823-1.127 4.393 4.393 0 00-1.35-.857 5.006 5.006 0 00-1.927-.334 4.533 4.533 0 00-2.776.896 4.772 4.772 0 00-1.684 2.514l8.881-.004zM89.495 18.546h4.61v2.21h.299a5.57 5.57 0 012.1-1.987 6.953 6.953 0 013.521-.823 7.929 7.929 0 013.354.728 8.911 8.911 0 012.811 2.027 9.597 9.597 0 011.932 3.089 11.244 11.244 0 010 7.87 9.648 9.648 0 01-1.932 3.092 8.974 8.974 0 01-2.811 2.023 7.936 7.936 0 01-3.354.732 6.954 6.954 0 01-3.522-.827 5.603 5.603 0 01-2.099-1.983h-.3l.3 2.622V45h-4.91V18.546zm9.519 14.424a4.713 4.713 0 001.855-.372 4.865 4.865 0 001.555-1.05 5.099 5.099 0 001.088-1.65 5.946 5.946 0 000-4.348 5.146 5.146 0 00-1.088-1.65 4.95 4.95 0 00-1.555-1.049 4.717 4.717 0 00-1.855-.372 4.928 4.928 0 00-1.855.355 4.676 4.676 0 00-1.555 1.033 5.089 5.089 0 00-1.084 1.649 6.087 6.087 0 000 4.421 5.14 5.14 0 001.084 1.65c.442.445.972.795 1.555 1.028.589.239 1.219.36 1.855.355zM129.366 32.482a10.274 10.274 0 01-3.427 3.637 9.526 9.526 0 01-5.265 1.388 10.063 10.063 0 01-3.877-.732 9.265 9.265 0 01-5.141-5.141 10.27 10.27 0 01-.728-3.916c-.007-1.29.234-2.568.711-3.766a9.498 9.498 0 015.004-5.23 9.247 9.247 0 013.855-.785 10.001 10.001 0 013.937.729 8.015 8.015 0 012.884 2.026 8.638 8.638 0 011.76 3.05c.409 1.234.611 2.526.6 3.826v.45a2.461 2.461 0 00-.038.428 2.367 2.367 0 00-.035.429h-13.842c.075.677.285 1.332.617 1.927.298.522.693.98 1.166 1.35.449.359.964.627 1.516.788a5.89 5.89 0 001.684.244 4.793 4.793 0 002.793-.766 5.625 5.625 0 001.744-1.933l4.082 1.997zm-4.459-7.116a3.164 3.164 0 00-.317-1.088 3.939 3.939 0 00-.823-1.127 4.441 4.441 0 00-1.349-.857 5.05 5.05 0 00-1.932-.334 4.51 4.51 0 00-2.772.895 4.75 4.75 0 00-1.688 2.515l8.881-.004zM131.727 32.859l9.369-10.12h-9.069v-4.193h15.101v4.044l-9.365 10.119h9.524v4.198h-15.551l-.009-4.048zM149.677 32.859l9.37-10.12h-9.07v-4.193h15.102v4.044l-9.37 10.119h9.519v4.198h-15.551V32.86zM179.469 34.958h-.3a8.308 8.308 0 01-2.082 1.8 5.91 5.91 0 01-3.128.75 7.572 7.572 0 01-2.677-.472 6.924 6.924 0 01-2.194-1.285 5.7 5.7 0 01-1.46-1.984 6.097 6.097 0 01-.527-2.549c-.014-.89.179-1.77.565-2.57a5.815 5.815 0 011.572-1.967 7.13 7.13 0 012.378-1.255 9.894 9.894 0 012.999-.428c.994-.021 1.988.074 2.96.282.65.15 1.288.342 1.911.579v-.562a2.995 2.995 0 00-1.161-2.416 4.396 4.396 0 00-2.888-.955 5.392 5.392 0 00-4.309 2.142l-3.56-2.433c1.95-2.45 4.611-3.675 7.981-3.672 2.856 0 5.029.668 6.52 2.005 1.491 1.337 2.241 3.316 2.249 5.938v11.001h-4.849v-1.949zm0-5.51a10.232 10.232 0 00-1.782-.655 7.77 7.77 0 00-2.005-.244 4.251 4.251 0 00-2.716.767 2.348 2.348 0 00-.956 1.893 2.144 2.144 0 00.921 1.8c.613.45 1.356.686 2.117.672a4.526 4.526 0 003.204-1.285c.384-.387.69-.846.9-1.35.209-.506.317-1.049.317-1.597zM191.16 36.907a3.198 3.198 0 01-2.305-.925 2.98 2.98 0 01-.715-1.01 2.976 2.976 0 01-.24-1.214 2.914 2.914 0 01.942-2.206 3.23 3.23 0 012.305-.904 3.16 3.16 0 012.284.904 2.94 2.94 0 01.938 2.206 2.993 2.993 0 01-.938 2.224 3.13 3.13 0 01-2.271.925zM215.704 32.22a10.255 10.255 0 01-3.355 3.805 9.288 9.288 0 01-5.376 1.482 10.196 10.196 0 01-3.916-.732 9.15 9.15 0 01-3.072-2.044 9.504 9.504 0 01-2.026-3.089 10.271 10.271 0 01-.728-3.915 10.42 10.42 0 01.728-3.938 9.132 9.132 0 015.098-5.132 10.197 10.197 0 013.916-.728 9.365 9.365 0 015.359 1.46 8.64 8.64 0 013.183 3.784l-4.494 1.91a4.832 4.832 0 00-1.632-1.932 4.421 4.421 0 00-2.489-.655 4.574 4.574 0 00-1.838.372 4.775 4.775 0 00-1.517 1.05 4.822 4.822 0 00-1.032 1.65 6.527 6.527 0 000 4.348 4.782 4.782 0 001.032 1.65c.432.445.947.802 1.517 1.049.58.25 1.206.376 1.838.372.916.03 1.82-.212 2.6-.694a4.759 4.759 0 001.714-2.005l4.49 1.933zM218.702 36.907V10.09h4.91v26.818h-4.91zM238.936 34.958h-.3a8.334 8.334 0 01-2.078 1.8 5.918 5.918 0 01-3.127.75 7.593 7.593 0 01-2.682-.472 6.955 6.955 0 01-2.193-1.285 5.818 5.818 0 01-1.461-1.984 6.16 6.16 0 01-.523-2.549 5.664 5.664 0 012.142-4.533 7.157 7.157 0 012.382-1.255 9.852 9.852 0 012.978-.428c.994-.02 1.987.074 2.96.283.65.147 1.288.34 1.911.578v-.561a2.995 2.995 0 00-1.161-2.416 4.384 4.384 0 00-2.883-.956 5.391 5.391 0 00-4.31 2.142l-3.56-2.433c1.948-2.45 4.608-3.674 7.981-3.672 2.856 0 5.029.669 6.52 2.005 1.491 1.337 2.241 3.316 2.249 5.938v10.997h-4.845v-1.949zm0-5.51a10.17 10.17 0 00-1.778-.655 7.796 7.796 0 00-2.005-.244 4.247 4.247 0 00-2.716.767 2.342 2.342 0 00-.955 1.893 2.14 2.14 0 00.917 1.8c.613.449 1.356.685 2.116.672a4.526 4.526 0 003.204-1.285 4.173 4.173 0 001.217-2.947zM250.405 16.087a3.132 3.132 0 01-1.221-.245 3.057 3.057 0 01-1.011-.672 3.161 3.161 0 01-.673-.994 3.255 3.255 0 010-2.472 3.154 3.154 0 012.905-1.91 3.1 3.1 0 012.249.916 3.118 3.118 0 01.934 2.23 3.117 3.117 0 01-.934 2.23 3.103 3.103 0 01-2.249.917zm-2.442 20.82V18.546h4.909v18.361h-4.909zM257.388 18.546h4.605v2.395h.3a6.43 6.43 0 012.343-2.172 6.638 6.638 0 013.278-.823 6.088 6.088 0 013.525.973 5.474 5.474 0 012.023 2.399 7.546 7.546 0 012.437-2.382 7.026 7.026 0 013.822-.99c1-.024 1.995.16 2.921.54.791.34 1.491.86 2.044 1.52.558.691.971 1.487 1.217 2.34.289.973.433 1.983.428 2.999v11.567h-4.952V26.227c0-2.496-1.024-3.745-3.072-3.748a3.381 3.381 0 00-1.714.428 3.782 3.782 0 00-1.255 1.161 5.684 5.684 0 00-.788 1.744 8.006 8.006 0 00-.279 2.172v8.923h-4.888v-10.68c0-2.496-1.075-3.745-3.226-3.748a3.135 3.135 0 00-1.649.428c-.48.293-.889.69-1.195 1.161a5.532 5.532 0 00-.75 1.744c-.181.71-.27 1.44-.266 2.172v8.923h-4.909V18.546zM297.431 37.507a10.508 10.508 0 01-3.2-.428 8.829 8.829 0 01-2.434-1.183 7.712 7.712 0 01-1.743-1.688 8.08 8.08 0 01-1.088-1.927l4.387-1.873a4.751 4.751 0 001.713 2.117c.707.46 1.534.702 2.378.694a4.04 4.04 0 002.142-.489 1.386 1.386 0 00.784-1.16 1.437 1.437 0 00-.656-1.217 6.722 6.722 0 00-2.266-.857l-2.57-.566a8.996 8.996 0 01-1.783-.595 7.017 7.017 0 01-1.666-1.05 5.315 5.315 0 01-1.238-1.538 4.327 4.327 0 01-.484-2.099 4.903 4.903 0 01.578-2.399 5.389 5.389 0 011.594-1.778 7.638 7.638 0 012.377-1.127 10.659 10.659 0 012.944-.39 10.34 10.34 0 014.682 1.029 6.37 6.37 0 013.038 3.281l-4.237 1.714a3.224 3.224 0 00-1.534-1.572 4.633 4.633 0 00-2.026-.489 3.754 3.754 0 00-1.834.429 1.28 1.28 0 00-.788 1.105 1.13 1.13 0 00.655 1.015 7.767 7.767 0 001.782.673l2.811.677c1.873.445 3.266 1.16 4.177 2.142a4.99 4.99 0 011.366 3.504 4.875 4.875 0 01-.561 2.288 6.047 6.047 0 01-1.594 1.928 7.704 7.704 0 01-2.472 1.332 9.94 9.94 0 01-3.234.497z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_66",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H305.262V45H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (TepezzaLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/tepezzaWrapper.tsx










const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
function TepezzaWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Tepezza",
                    domain: "Tepezza.Claims"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Tepezza",
                    domain: "Tepezza.Claims"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        textColor: (tepezzaVariables_module_default()).mainColor,
                        iconColor: (tepezzaVariables_module_default()).mainColor,
                        phoneNumberColor: (tepezzaVariables_module_default()).mainColor,
                        slogan: `find the best Tepezza lawyers ${region ? `in ${region}` : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4 ",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        bgColor: (tepezzaVariables_module_default()).secondaryColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 71020:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#1e4e35","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d"};

/***/ })

}]);